import { ArrowUp } from "lucide-react";
import { useLang } from "../i18n/LangContext";
import { usePlaceholder } from "../lib/usePlaceholder";
import { scrollToId } from "../lib/util";
import { Logo } from "../components/Logo";

const PH = ({ k, children }) => {
  const ph = usePlaceholder(k);
  return (
    <a {...ph} data-testid={`footer-${k}`} className="footer-link">
      {children}
    </a>
  );
};

const Col = ({ title, children }) => (
  <div>
    <p className="text-xs text-noor-champagne">{title}</p>
    <ul className="mt-5 flex flex-col gap-3 text-[15px]">{children}</ul>
  </div>
);

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  return (
    <footer data-testid="footer" className="relative z-[2] overflow-hidden bg-noor-ink pt-24 text-noor-pearl">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo size="lg" />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-noor-mist">{f.desc}</p>
            <p className="mt-6 font-display text-xl text-noor-champagne">{t.tagline}</p>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 md:col-span-7">
            <Col title={f.explore}>
              <li><button data-testid="footer-services" onClick={() => scrollToId("services")} className="footer-link">{f.services}</button></li>
              <li><button data-testid="footer-how" onClick={() => scrollToId("how")} className="footer-link">{f.how}</button></li>
              <li><button data-testid="footer-about" onClick={() => scrollToId("about")} className="footer-link">{f.about}</button></li>
            </Col>
            <Col title={f.company}>
              <li><PH k="contact">{f.contact}</PH></li>
              <li><a className="text-sm text-noor-mist" data-testid="footer-email" dir="ltr" style={{ overflowWrap: "anywhere" }} href="mailto:noorin.strategy@gmail.com">noorin.strategy@gmail.com</a></li>
              <li><PH k="privacy">{f.privacy}</PH></li>
              <li><PH k="terms">{f.terms}</PH></li>
            </Col>
            <Col title={f.social}>
              <li><a href="https://www.instagram.com/noorin.strategy/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="footer-link">Instagram</a></li>
              <li><a href="https://wa.me/message/T2GHGI3EDEABB1" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="footer-link">WhatsApp</a></li>
              <li><a href="https://t.me/Noorin_strategy" target="_blank" rel="noopener noreferrer" data-testid="footer-telegram" className="footer-link">Telegram</a></li>
            </Col>
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-4 border-t border-noor-pearl/10 py-8 text-xs text-noor-mist md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-copyright">{f.copyright}</span>
          <span>{f.proto}</span>
          <button data-testid="footer-back-to-top" onClick={() => scrollToId("home")} className="inline-flex items-center gap-2 text-noor-pearl transition-colors hover:text-noor-champagne">
            {f.top} <ArrowUp size={14} />
          </button>
        </div>
      </div>
      <div aria-hidden className="pointer-events-none select-none px-4 pb-4" dir="ltr">
        <img src="/brand/wordmark-dark.png" alt="" className="mx-auto w-full max-w-[1400px] opacity-[0.06]" />
      </div>
    </footer>
  );
};
